"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var autocomplete_1 = __importDefault(require("./autocomplete"));

var date_1 = __importDefault(require("./date"));

var input_1 = __importDefault(require("./input"));

var input_number_1 = __importDefault(require("./input-number"));

var select_1 = __importDefault(require("./select"));

var switch_1 = __importDefault(require("./switch"));

var textarea_1 = __importDefault(require("./textarea"));

var code_1 = __importDefault(require("./code"));

var InputGeneric = function InputGeneric(props) {
  var field = props.field,
      data = props.data,
      onChange = props.onChange;
  var name = field.name,
      type = field.type,
      promise = field.promise,
      options = field.options,
      ux = field.ux,
      inputProps = field.inputProps;

  switch (ux || type) {
    case 'select':
      return react_1.default.createElement(select_1.default, Object.assign({
        promise: promise,
        name: name,
        data: data,
        onChange: onChange,
        options: options
      }, inputProps));

    case 'boolean':
      return react_1.default.createElement(switch_1.default, Object.assign({
        data: data,
        name: name,
        onChange: onChange
      }, inputProps));

    case 'date':
      return react_1.default.createElement(date_1.default, Object.assign({
        data: data,
        name: name,
        onChange: onChange
      }, inputProps));

    case 'number':
      return react_1.default.createElement(input_number_1.default, Object.assign({
        data: data,
        name: name,
        onChange: onChange
      }, inputProps));

    case 'autocomplete':
      return react_1.default.createElement(autocomplete_1.default, Object.assign({
        data: data,
        name: name,
        options: options ? options : [],
        onChange: onChange
      }, inputProps));

    case 'textarea':
      return react_1.default.createElement(textarea_1.default, Object.assign({
        name: name,
        data: data,
        onChange: onChange
      }, inputProps));

    case 'code':
      return react_1.default.createElement(code_1.default, Object.assign({
        name: name,
        data: data,
        onChange: onChange
      }, inputProps));

    default:
      return react_1.default.createElement(input_1.default, Object.assign({
        name: name,
        data: data,
        onChange: onChange
      }, inputProps));
  }
};

exports.default = InputGeneric;